<template>
  <IQOS :title="$t('campaign_card.iqos_title')" :readonly="editing">
    <h4 class="campaign-title" v-if="!editing">{{ campaign.title }}</h4>
    <!-- <h4 class="campaign-title" v-if="editing">
      
    </h4>-->
    <BaseInput
      class="campaign-title-edit"
      :placeholder="$t('campaign_card.title_ph')"
      v-model="edit_fields.title"
      :readonly="false"
      v-if="editing"
    />
    <p class="campaign-param iqos-group-item" v-if="!editing">
      {{$t('campaign_card.period')}}
      <span class="campaign-param-value">
        {{ campaign.period_start | formatDate }}
        -
        {{ campaign.period_end | formatDate}}
      </span>
    </p>
    <p
      class="campaign-param campaign-period-param campaign-period-box iqos-group-item"
      v-if="editing"
    >
      <!-- {{ $t('campaign_card.period') }} -->
      <v-date-picker
        v-model="picker_range.start"
        class="campaign-period-widget"
        locale="uk"
        is-dark
        color="green"
        v-if="editing"
      />
      <span class="period-divider">-</span>
      <v-date-picker
        v-model="picker_range.end"
        class="campaign-period-widget"
        locale="uk"
        is-dark
        color="green"
        v-if="editing"
      />
    </p>
    <div v-if="editing && canSetForceMode">
      <BlackSelect class="iqos-group-item" :readonly="false" v-model="edit_fields.force_mode">
        <option :value="null">{{ $t('campaign_card.force_mode_none') }}</option>
        <option :value="'preorder'" v-if="cafe.modes.preorder">TAKEAWAY</option>
        <option :value="'delivery'" v-if="cafe.modes.delivery">DELIVERY</option>
        <option :value="'reserve'" v-if="cafe.modes.reserve">RESERVE</option>
      </BlackSelect>
    </div>
    <p class="campaign-param iqos-group-item" v-if="!editing">
      {{ $t('campaign_card.total_visits') }}
      <span
        class="campaign-param-value"
      >{{ campaign.total_visits }}</span>
    </p>
    <p class="campaign-param iqos-group-item" v-if="!editing">
      {{ $t('campaign_card.unique_visits') }}
      <span
        class="campaign-param-value"
      >{{ campaign.unique_visits }}</span>
    </p>
    <p class="campaign-link-container iqos-group-item">
      <a class="campaign-link" :href="referralLink" target="_blank">{{ referralLink }}</a>
    </p>
    <p class="comment pt-0 c-grey">{{ $t('campaign_card.iqos_desc') }}</p>
    <DashboardButton
      @click="deleting = true"
      variant="danger"
      class="iqos-group-item"
      v-if="editing"
    >{{ $t('campaign_card.delete') }}</DashboardButton>

    <IQOSActions :editing="editing" @edit="showEditUI" @accept="onEditFinish" @cancel="hideEditUI" />
    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="onDelete"
      v-if="deleting"
    >{{ $t('campaign_card.confirm_delete') }}</DangerConfirmModal>
  </IQOS>
</template>

<script>
import ReferralsAPI from "@/api/referrals";

import moment from "moment";

export default {
  data() {
    return {
      editing: false,
      edit_fields: {
        title: null,
        period_start: null,
        period_end: null,
        force_mode: null
      },
      picker_range: {
        start: null,
        end: null,
      },
      deleting: false,
    };
  },
  methods: {
    onEditFinish() {
      ReferralsAPI.updateCampaign(
        this.campaign._id,
        this.edit_fields.title,
        this.picker_range.start,
        this.picker_range.end,
        this.edit_fields.force_mode.length ? this.edit_fields.force_mode : null
      )
        .then((data) => {
          this.editing = false;
          this.$emit("updated");
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
          this.editing = false;
        });
    },
    onDelete() {
      ReferralsAPI.removeCampaign(this.campaign._id)
        .then((data) => {
          this.deleting = false;

          this.$store.dispatch("auditlog/write", {
            type: "marketing_remove_campaign",
            payload: {
              title: this.campaign.title,
            },
          });

          this.$emit("updated");
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
          this.deleting = false;
        });
    },
    showEditUI() {
      this.editing = true;

      this.edit_fields.title = this.campaign.title;
      this.edit_fields.force_mode = this.campaign.force_mode;

      this.picker_range.start = moment(this.campaign.period_start).toDate();
      this.picker_range.end = moment(this.campaign.period_end).toDate();
    },
    hideEditUI() {
      this.editing = false;
    },
  },
  computed: {
    onlineMenuLink() {
      return this.$store.getters.onlineMenuLink("local");
    },
    referralLink() {
      return `${this.onlineMenuLink}?cmpid=${this.campaign.referral_id}`;
    },
    cafe() {
      return this.$store.state.cafe;
    },
    canSetForceMode() {
      return (this.cafe.modes.preorder + this.cafe.modes.delivery + this.cafe.modes.reserve) > 1;
    }
  },
  props: {
    campaign: Object,
  },
};
</script>

<style scoped>
.campaign-title {
  color: #ededed;
  font-size: 2.5vh;
  margin-bottom: 1vh;
}

.campaign-title-edit {
  text-align: center;
}

a.campaign-link {
  line-height: normal;
}

.campaign-param {
  color: #ededed;
  font-size: 1.7vh;
  margin-bottom: 0;
}

.campaign-param-value {
  color: #129b81;
}

.campaign-title-edit {
  text-align: left;
  width: 100%;
}

.campaign-period-param {
  display: flex;
}

.campaign-period-widget {
  /* margin-left: 1vh; */
}

.campaign-delete-btn {
  width: 20vh;
  margin-top: 2vh;
}

.campaign-link-container {
  border: 1px solid #ededed;
  padding: 0.6vh 0.7vh;
  border-radius: 0.8vh;
  text-align: center;
}

.campaign-period-box {
}

.period-divider {
  color: #ededed;
  margin: 0 1.6vh;
  font-size: 2vh;
}
</style>